export { default } from '@/screens/IntroScreen';
